import { Grid } from "@mui/material";
import { Stack } from "@mui/system";
import { decrypt } from "../../../../utils/encryptDecrypt";

const PaymentSlip = (_props) => {
    const { className, paymentDetails, appliedPost, email } = _props

    return (
        <fieldset className={`${className}--fieldset`}>
            <legend className={`${className}--legend`}>
                Payment Confirmation Details
            </legend>
            <p className={`${className}--textPrimary`}>
                Your transaction has been
                <span
                    className={`${paymentDetails?.order_status === "Success"
                        ? "text-success"
                        : "text-fail"
                        }`}
                >
                    {" "}
                    {paymentDetails?.order_status === "Success"
                        ? "Successful"
                        : "Failed"}
                </span>
                . Kindly print this page for your reference and remember to quote
                your Transaction Number in all future communication regarding the
                payment.
            </p>

            <Stack
                direction={{
                    lg: "row",
                    md: "row",
                    sm: "row",
                    xs: "column-reverse",
                }}
                justifyContent="space-between"
                mt={5}
                spacing={4}
            >
                <div className="print-web">
                    <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Exam Name
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--text`}>
                                {appliedPost.length ? appliedPost?.toString() : "-"}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Candidate's Name
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.name ? decrypt(paymentDetails?.name) : "-"}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Email Id
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>{email}</p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Application Number
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.application_no}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Order ID
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.order_id}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Transaction Ref. No.
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.bank_ref_no !== "null"
                                    ? paymentDetails?.bank_ref_no
                                    : "-"}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>Amount</p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                ₹ {(paymentDetails?.amount || 0).toFixed(2)}
                            </p>
                        </Grid>
                        {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className={`${className}--textSecondary`}>
                  Transaction Status
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className={`${className}--textTertiary`}>{paymentDetails?.order_status}</p>
              </Grid> */}
                        {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className={`${className}--textSecondary`}>
                  Transaction Number
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className={`${className}--textTertiary`}>
                  {paymentDetails?.order_id}
                </p>
              </Grid> */}
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Tracking ID
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.tracking_id !== "null"
                                    ? paymentDetails?.tracking_id
                                    : "-"}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Order Status
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p
                                className={`${className}--textTertiary ${paymentDetails?.order_status === "Success"
                                    ? "text-success"
                                    : "text-fail"
                                    } `}
                            >
                                {paymentDetails?.order_status}
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textSecondary`}>
                                Date of Transaction
                            </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.trans_date !== "null"
                                    ? paymentDetails?.trans_date
                                    : "-"}
                            </p>
                        </Grid>
                    </Grid>
                </div>
                <div className="print-view">
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Exam Name
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--text`}>
                                {appliedPost.length ? appliedPost?.toString() : "-"}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Candidate's Name
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.name ? decrypt(paymentDetails?.name) : "-"}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Email Id
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>{email}</p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Application Number
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.application_no}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Order ID
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.order_id}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Transaction Ref. No.
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.bank_ref_no !== "null"
                                    ? paymentDetails?.bank_ref_no
                                    : "-"}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>Amount</p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                ₹ {(paymentDetails?.amount || 0).toFixed(2)}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Tracking ID
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.tracking_id !== "null"
                                    ? paymentDetails?.tracking_id
                                    : "-"}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Order Status
                            </p>
                        </div>
                        <div className="w-50">
                            <p
                                className={`${className}--textTertiary ${paymentDetails?.order_status === "Success"
                                    ? "text-success"
                                    : "text-fail"
                                    } `}
                            >
                                {paymentDetails?.order_status}
                            </p>
                        </div>
                    </div>
                    <div className="print-details d-flex">
                        <div className="w-50">
                            <p className={`${className}--textSecondary`}>
                                Date of Transaction
                            </p>
                        </div>
                        <div className="w-50">
                            <p className={`${className}--textTertiary`}>
                                {paymentDetails?.trans_date !== "null"
                                    ? paymentDetails?.trans_date
                                    : "-"}
                            </p>
                        </div>
                    </div>
                </div>
            </Stack>
        </fieldset>
    )
}

export default PaymentSlip;